/** biome-ignore-all lint/complexity/useArrowFunction: no */
import EgoForm from "@egodesign/form";
import EgoModal from "@egodesign/modal";
import { getRecaptchaToken } from "../../modules/form-helpers";
import { sullairGoSuscriptionFormGTM } from "../../modules/marketing/gtm";

document.addEventListener("DOMContentLoaded", function () {
	const burger = document.querySelector(".sullairgo-header__burger");
	const closeBtn = document.querySelector(".sullairgo-header__nav-mob .close");

	const header = document.querySelector(".sullairgo-header");
	const mobMenu = document.querySelector(".sullairgo-header__nav-mob");
	burger.addEventListener("click", function () {
		mobMenu.classList.toggle("open");
		document.body.classList.toggle("no-scroll");
	});

	closeBtn.addEventListener("click", function () {
		mobMenu.classList.toggle("open");
		document.body.classList.toggle("no-scroll");
	});

	// TYC Modal
	const tycModal = new EgoModal({
		element: document.querySelector("#tycModal"),
	});

	const openTycModal = document.querySelector(".open-tyc-modal");
	openTycModal.addEventListener("click", function () {
		tycModal.open();
	});

	// FORM MODAL
	const formModal = new EgoModal({
		element: document.querySelector("#formModal"),
		onClose: () => changeModalView("content-form"),
	});

	const openFormModal = document.querySelectorAll(".open-form-modal");
	openFormModal.forEach((el) => {
		el.addEventListener("click", function () {
			formModal.open();
		});
	});

	// FORM
	const form = document.querySelector(".sg-custom-modal__content-form");
	const emailField = document.querySelector(
		'.sg-custom-modal__content-form input[name="email"]',
	);
	const firstNameField = document.querySelector(
		'.sg-custom-modal__content-form input[name="name"]',
	);
	const lastNameField = document.querySelector(
		'.sg-custom-modal__content-form input[name="surname"]',
	);
	const dniField = document.querySelector(
		'.sg-custom-modal__content-form input[name="dni"]',
	);
	const submitBtn = document.querySelector(".submit-form");
	const emailTest = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

	emailField.addEventListener("input", validateForm);
	firstNameField.addEventListener("input", validateForm);
	lastNameField.addEventListener("input", validateForm);
	dniField.addEventListener("input", maskDNI);

	function maskDNI(e) {
		const input = e.target;
		input.value = input.value.replace(/\D/g, "");
		validateForm();
	}

	function validateForm() {
		const basicValid =
			emailTest.test(emailField.value) &&
			firstNameField.value.length > 1 &&
			lastNameField.value.length > 1;

		const dniValid =
			!dniField.value ||
			(dniField.value.length >= 7 && dniField.value.length <= 8);

		submitBtn.disabled = !(basicValid && dniValid);
	}

	const csrf = form.querySelector("[name=csrfmiddlewaretoken]").value;
	const sgForm = new EgoForm({
		element: form,
		submitDataFormat: "json",
		submitType: "fetch",
		requestHeaders: {
			"X-CSRFToken": csrf,
		},
		onSuccess: () => {
			form.reset();
			changeModalView("content-success");
			sullairGoSuscriptionFormGTM(form, "success");
		},
		onError: () => {
			changeModalView("content-error");
			sullairGoSuscriptionFormGTM(form, "error");
		},
		onBeforeSubmit: async () => {
			sgForm.submittingForm(true);
			const recaptchaToken = await getRecaptchaToken();
			if (recaptchaToken) {
				sgForm.extraFields.push({
					name: "recaptcha_token",
					value: recaptchaToken,
				});
				sgForm.resumeSubmit();
			} else {
				sgForm.submittingForm(false);
				sgForm.onError();
			}
		},
		preventSubmit: true,
	});

	// FIX HEADER
	const loginPosition =
		Math.round(document.querySelector(".sullairgo-section__login").offsetTop) -
		100;

	function controlHeader() {
		const docTop = document.documentElement.scrollTop;

		if (docTop >= 3) {
			header.classList.add("--fixed");
		} else {
			header.classList.remove("--fixed");
		}

		if (docTop >= loginPosition) {
			header.classList.add("--hide");
		} else {
			header.classList.remove("--hide");
		}
	}

	controlHeader();
	window.addEventListener("scroll", controlHeader);

	// Casuisticas
	function changeModalView(id) {
		const current = document.querySelector(".sg-custom-modal__content.active");
		const next = document.getElementById(id);

		if (next) {
			current.classList.remove("active");
			next.classList.add("active");
		}
	}

	const backToFormButton = document.querySelector(".back-to-form");
	backToFormButton.addEventListener("click", function () {
		changeModalView("content-form");
	});
});
